const QorpyApiInterface = require('./qorpy')

module.exports = { QorpyApiInterface }
